import React from 'react'
import { navigate } from '@reach/router'
import styled from 'styled-components'
import { handleLogin, isLoggedIn, handleSignIn } from '../../services/auth'
import { device } from '../Breakpoints'
import { Breadcrumb } from '../Breadcrumb'
import header from '../../img/agendamento-visita-topo-b.jpg'
import headerMobile from '../../img/agendamento-mobile.jpg'

const Container = styled.section`
  width: 100%;
  margin-bottom: 2em;
  .pageHeader {
    margin: auto;
    width: 100%;
    display: block;
    @media ${device.mobileL} {
      display: none;
    }
  }
  .pageHeaderMobile {
    margin: auto;
    width: 100%;
    display: none;
    @media ${device.mobileL} {
      display: block;
    }
  }
`

const GroupContent = styled.section`
  padding: 2em 0;
  .columns {
    display: flex;
    justify-content: space-between;

    @media ${device.mobileL} {
      flex-wrap: wrap;
    }
    small {
      color: #de9b9b;
      font-size: 10px !important;
      margin-bottom: 30px;
      display: block;
    }
    p {
      font-size: 16px !important;
      margin: 0;
      width: 80%;
    }
    .form {
      @media ${device.mobileL} {
        text-align: center;
      }
      input {
        background: none;
        border-top: none;
        border-left: none;
        border-right: none;
        border-bottom: 1px solid #707070;
        padding: 1em 0;
        width: 80%;
        margin-bottom: 10px;
        @media ${device.mobileL} {
          width: 100%;
        }
      }
    }
    .col1,
    .col2 {
      width: 50%;
      box-sizing: border-box;
      h2 {
        color: #fa7272;
        font-size: 20px !important;
        max-width: 80%;
        @media ${device.mobileL} {
          max-width: 100%;
        }
      }
      @media ${device.mobileL} {
        width: 100%;
      }
    }
    .col1 {
      border-right: 1px solid #fa7272;
      padding-right: 3em;
      @media ${device.mobileL} {
        padding-right: 0em;
        border-right: none;
        margin-bottom: 2em;
      }
    }
    .col2 {
      padding-left: 3em;
      @media ${device.mobileL} {
        padding-left: 0;
      }
    }
  }
  @media ${device.mobileL} {
    padding: 2em;
    p {
      text-align: left;
    }
  }
`
const crumbs = [
  { id: 1, link: '/', title: 'Home', icon: true },
  { id: 2, link: '#', title: 'Agendamento' },
]
class Login extends React.Component {
  state = {
    email: ``,
    emailSignIn: ``,
    password: ``,
    passwordSignIn: ``,
    celular: ``,
    nome: ``,
    cpf: ``,
  }

  handleUpdate(event) {
    this.setState({
      [event.target.name]: event.target.value,
    })
  }

  handleSubmit(event) {
    event.preventDefault()
    handleLogin(this.state)
  }

  handleSignInSubmit(event) {
    event.preventDefault()
    handleSignIn(this.state)
  }

  render() {
    if (isLoggedIn()) {
      navigate(`/agendamento-de-visitas/convenios`)
    }

    return (
      <Container>
        <Breadcrumb crumbs={crumbs} />
        <img src={header} alt="Agendamento" className="pageHeader" />
        <img
          src={headerMobile}
          alt="Agendamento"
          className="pageHeaderMobile"
        />
        <GroupContent>
          <div className="center columns">
            <div className="col1">
              <h2>
                Já é cadastrado(a) e quer fazer ou alterar um agendamento?
              </h2>

              <form
                className="form"
                method="post"
                onSubmit={event => {
                  this.handleSubmit(event)
                }}
              >
                <input
                  type="email"
                  name="email"
                  placeholder="Digite seu e-mail"
                  onChange={e => this.handleUpdate(e)}
                />
                <input
                  type="password"
                  name="password"
                  placeholder="Digite sua senha"
                  onChange={e => this.handleUpdate(e)}
                />

                <button type="submit" className="button">
                  Entrar
                </button>
              </form>
            </div>
            <div className="col2">
              <h2>Ainda não sou cadastrado.</h2>
              <p>
                Preencha o formulário abaixo com seus dados para se cadastrar:
              </p>
              <small>
                CAMPOS MARCADOS COM * SÃO DE PREENCHIMENTO OBRIGATÓRIO
              </small>
              <form
                className="form"
                method="post"
                onSubmit={event => {
                  this.handleSignInSubmit(event)
                }}
              >
                <input
                  type="text"
                  name="nome"
                  placeholder="Nome completo*"
                  onChange={e => this.handleUpdate(e)}
                />
                <input
                  type="text"
                  name="celular"
                  placeholder="Celular*"
                  onChange={e => this.handleUpdate(e)}
                />
                <input
                  type="email"
                  name="emailSignIn"
                  placeholder="E-mail*"
                  onChange={e => this.handleUpdate(e)}
                />
                <input
                  type="text"
                  name="cpf"
                  placeholder="CPF*"
                  onChange={e => this.handleUpdate(e)}
                />
                <input
                  type="password"
                  name="passwordSignIn"
                  placeholder="Senha"
                  onChange={e => this.handleUpdate(e)}
                />
                <button
                  type="submit"
                  className="button"
                  onChange={e => this.handleUpdate(e)}
                >
                  Cadastrar
                </button>
              </form>
            </div>
          </div>
        </GroupContent>
      </Container>
    )
  }
}

export default Login
